// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__BC4pM","title":"Header_title__1lqTL","side":"Header_side__wTnmP"};